var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55915 14.5C6.89879 15.5612 8.1678 16 10 16C14.026 16 17.3482 12.9463 17.8338 9H19.0115C19.7997 9 20.2698 8.10985 19.8326 7.4453L17.7291 4.24808C17.3385 3.65434 16.4775 3.65434 16.0869 4.24808L13.9834 7.4453C13.5462 8.10985 14.0163 9 14.8045 9H15.8393C15.3695 11.8377 12.9339 14 10 14C8.92109 14 7.90957 13.7076 7.03843 13.1967L5.55915 14.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9615 2.80326C12.0904 2.2924 11.0789 2 10 2C7.06607 2 4.63054 4.16229 4.16072 7H5.19546C5.98366 7 6.45379 7.89015 6.01658 8.5547L3.91311 11.7519C3.52249 12.3457 2.66149 12.3457 2.27087 11.7519L0.167402 8.5547C-0.269813 7.89014 0.200319 7 0.988518 7H2.16621C2.65184 3.05369 5.97399 0 10 0C11.8322 0 13.1012 0.438812 14.4409 1.5L12.9615 2.80326Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refreshIcon.4a8d5e07e47929c921a2ff17204b8ba4.svg";
export { ForwardRef as ReactComponent };